import * as glb from '../globals.js';
import { EKIM_KANAL_CE_TUR_ST_TUR } from './ekimKanalKullanici.js';

const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

/** SABIT ST_TUR=110 satırı (CE_TUR = ST_KODINT). */
export function getEkimKanalCeTurRow(ceTur, sabitLkp = null) {
  const ceTurNum = toNumber(ceTur);
  if (ceTurNum == null) return null;
  const list = Array.isArray(sabitLkp) ? sabitLkp : (glb.default?.sabitLkp || []);
  return list.find(
    (x) => Number(x.ST_TUR) === EKIM_KANAL_CE_TUR_ST_TUR
      && Number(x.ST_KODINT) === ceTurNum
      && !x.ST_SIL
  ) || null;
}

/** CE_TUR seçimine göre SABIT ST_TUR=110.ST_TUTAR → CE_TUTAR. */
export function resolveCeTutarFromCeTur(ceTur, sabitLkp = null) {
  const row = getEkimKanalCeTurRow(ceTur, sabitLkp);
  if (!row) return null;
  const tutar = toNumber(row.ST_TUTAR);
  return tutar != null ? tutar : null;
}
